'use client';

import { ArrowLeft, Download01, Share06 } from '@ethsign/icons';
import { Button } from '@ethsign/ui';

import { UserInfo } from '@/components/UserInfo';

import { ICurrentUser } from '@/types';

type Props = {
  isShowDownload?: boolean;
  onDownload?: () => void;
  onShare?: () => void;
  onBack: () => void;
  user?: ICurrentUser;
};
export const Header = (props: Props) => {
  const { isShowDownload = true, onDownload, onShare, onBack, user } = props;

  return (
    <div className="absolute flex bg-white h-[72px] w-full flex-row items-center px-10  justify-between border-b border-b-gray-100 text-lg font-medium text-gray-700">
      <div className="flex flex-row items-center cursor-pointer" onClick={onBack}>
        <ArrowLeft size={16} color="#344054" />
        <span className="ml-2 ">Dashboard</span>
      </div>
      <div className="flex flex-row items-center">
        {isShowDownload && (
          <Button variant="outline" className="flex flex-row items-center cursor-pointer" onClick={onDownload}>
            <Download01 size={20} color="#344054" />
            <span className="ml-2">Download Contract</span>
          </Button>
        )}
        <Button onClick={onShare} className="mx-4" variant="outline">
          <Share06 size={20} color="#344054" className={'inline-block mr-2'} />
          Share to Viewers
        </Button>
        {user ? <UserInfo user={user} /> : null}
      </div>
    </div>
  );
};
